import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from 'fuse-ui/components/FormControlLabel';
import Radio from 'fuse-ui/components/Radio';
import RadioGroup from 'fuse-ui/components/RadioGroup';
import React from 'react';
import Typography from 'fuse-ui/components/Typography';
import Input from 'fuse-ui/components/Input';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

import { comparatorFilterParams } from '../constants/filter-types';

const styles = theme => ( {
    flexDisplay: {
        display: 'flex',
        flexDirection: 'row',
    },
    formLabel: {
        '& >span:nth-child(2)': {
            margin: 0
        },
        paddingBottom: theme.spacing.unit,
    },
    text: {
        paddingLeft: theme.spacing.unit * 2,
        paddingTop: theme.spacing.unit,
    },
} );


const GreaterOrLessThanFilter = (
    {
        classes,
        comparatorValue,
        error,
        handleComparatorChange,
        inputValue = '',
        onSubmit,
        onTextChange,
    }
) => {
    return (
        <form  onSubmit={onSubmit}>
            {/* The inline styles are due to the fact that fuse UI has more specificity then our classes */}
            <FormControl component="fieldset" className={classes.flexDisplay}>
                <RadioGroup
                    aria-label="Total Volume"
                    name="totalVolume"
                    value={comparatorValue}
                    onChange={handleComparatorChange}
                    style={{ display: 'flex',  flexDirection: 'row' }}
                >
                    <FormControlLabel
                        data-automation-id="total-volume-filter-greater-than-radio"
                        value={comparatorFilterParams.greaterThan}
                        control={<Radio />}
                        label={comparatorFilterParams.greaterThan}
                        className={classes.formLabel}
                        style={ { display: 'flex', paddingLeft: '8px' } }
                    />
                    <FormControlLabel
                        data-automation-id="total-volume-filter-less-than-radio"
                        value={comparatorFilterParams.lessThan}
                        control={<Radio />}
                        label={comparatorFilterParams.lessThan}
                        className={classes.formLabel}
                        style={ { display: 'flex' } }
                    />
                </RadioGroup>
            </FormControl>
            <Input
                type="number"
                onChange={onTextChange}
                error={error}
                value={inputValue}
                data-automation-id="total-volume-filter-input"
            />
            {error ?
                <Typography variant="overline" color="error" className={classes.text}>You must enter a positive number</Typography> :
                <Typography variant="overline" color="textSecondary" className={classes.text}>Press 'Enter' to apply the filter</Typography>
            }
        </form>
    );
};

GreaterOrLessThanFilter.propTypes = {
    classes: PropTypes.object.isRequired,
    comparatorValue: PropTypes.string.isRequired,
    error: PropTypes.bool.isRequired,
    handleComparatorChange: PropTypes.func.isRequired,
    inputValue: PropTypes.string.isRequired,
    onSubmit: PropTypes.func.isRequired,
    onTextChange: PropTypes.func.isRequired,
    resetFilter: PropTypes.func.isRequired,
};

export default withStyles( styles )( GreaterOrLessThanFilter );
